import classnames from 'classnames';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { baseButtonClass } from 'components/Button';

type ButtonRadio = FieldRenderProps<string, HTMLElement, string> & {
  labelText?: string;
  labelClassName?: string;
  disabled?: boolean;
};

export const ButtonRadioGroup = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const containerClassName = classnames('flex items-center gap-3');

  return <div className={containerClassName}>{children}</div>;
};

const ButtonRadio: FC<ButtonRadio> = ({
  input,
  labelText,
  labelClassName,
  meta: { touched, error },
  icon,
  disabled,
  ...otherProps
}) => {
  const containerClassName = classnames(
    baseButtonClass,
    disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    input.checked
      ? 'border-accentGreen bg-accentGreen text-white'
      : disabled
        ? 'border-gray-200 bg-gray-100 text-gray-400'
        : 'border-gray-200 bg-gray-50 text-gray-900',
    labelClassName,
    {
      'border-red-800': touched && error,
    },
  );

  const domId = input.name + input.value;

  return (
    <>
      <label htmlFor={domId} className={containerClassName}>
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
            {icon}
          </span>
        )}
        {labelText || input.name}
        <input
          id={domId}
          type="radio"
          autoComplete="off"
          className="sr-only"
          style={{ display: 'none' }}
          {...input}
          {...otherProps}
          disabled={disabled}
        />
      </label>
      {touched && error && (
        <span className="text-xs text-red-800">{error}</span>
      )}
    </>
  );
};

export default ButtonRadio;
